import React from 'react';
import Layout from '../Components/Layout';

function Privacy(props) {
    return (
        <Layout>
            <section className='container common-space-both'>
                <div className='common-title'>
                    <h1 className='text-black !font-extrabold'>Privacy Statement</h1>
                    <p className='my-3'>A website privacy policy is a document that outlines how a website collects, uses, stores, and protects the personal information of its users. While I cannot provide you with the specific privacy policy of a particular website since I don't have access to real-time information, I can give you a general overview of what a typical website privacy policy includes. Here are some common elements found in website privacy policies:</p>
                    <ul className='list-decimal pl-5 text-black [&>li]:pb-3'>
                        <li>
                            Information Collection: This section explains what types of information the website collects from its users, such as names, email addresses, browsing data, and other relevant details.
                        </li>
                        <li>
                            Data Usage: The privacy policy describes how the collected information is used. This may include purposes like personalization, communication, analytics, marketing, or improving website functionality.
                        </li>
                        <li>
                            Data Sharing: It explains whether and how the website shares users' personal information with third parties, such as service providers, advertisers, or affiliated companies. It may also mention any sharing practices related to legal requirements or business transactions.
                        </li>
                        <li>
                            Cookies and Tracking Technologies: This section provides information about the use of cookies, web beacons, and similar technologies for tracking user behavior and preferences. It usually includes details on how users can manage their cookie preferences.
                        </li>
                        <li>
                            User Rights: This part explains the rights of users regarding their personal information, such as the ability to access, correct, or delete their data. It may also include information on how users can opt out of certain data processing activities.
                        </li>
                        <li>
                            Security Measures: The privacy policy should mention the security measures in place to protect users' personal information from unauthorized access, loss, or disclosure.
                        </li>
                        <li>
                            Legal Basis: If applicable, the privacy policy may state the legal basis for processing personal data, such as consent, legitimate interests, or contractual necessity.
                        </li>
                        <li>
                            Updates to the Privacy Policy: The policy should specify how any changes to the privacy policy will be communicated to users and when they will come into effect.
                        </li>
                        <li>
                            Remember that each website may have its own unique privacy policy, so it's essential to review the specific policy of the website you are concerned about. Typically, you can find a link to the privacy policy in the footer or legal section of a website.
                        </li>
                    </ul>

                </div>
            </section>
        </Layout>
    );
}

export default Privacy;